import React from 'react';
import {
  unstable_HistoryRouter as HistoryRouter,
  Route,
  Routes,
} from 'react-router-dom';
import ReactTracker from 'react-tracker-teko';
import { browserHistory } from 'helpers';
import './App.less';
import './App.scss';
import AppLayout from 'containers/AppLayout';
import { CartProvider as BaseCartProvider } from 'contexts/CartContext';
import { RoomProvider as BaseRoomProvider } from 'contexts/RoomContext';

const trackingAppId = window.REACT_APP_TRACKER_APP_ID;

const reactTracker = new ReactTracker({
  // Configure your tracker server and site by providing
  host: (trackingAppId && window.REACT_APP_TRACKER_HOST) || '',
  urlServeJsFile: (trackingAppId && window.REACT_APP_TRACKER_JS_FILE) || '',
  appId: trackingAppId || '',
});

const CombinedProvider: React.FC<{
  providers: React.FC<{ children: React.ReactNode }>[];
  children: React.ReactNode;
}> = ({ providers, children }) => {
  return (
    <>
      {providers.reduceRight((node, Provider) => {
        return <Provider>{node}</Provider>;
      }, children)}
    </>
  );
};
const App: React.FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const roomCode = urlParams.get('roomCode') || '';

  const RoomProvider = ({ children }: React.PropsWithChildren<any>) => (
    <BaseRoomProvider roomCode={roomCode}>{children}</BaseRoomProvider>
  );

  const CartProvider = ({ children }: React.PropsWithChildren<any>) => (
    <BaseCartProvider roomCode={roomCode}>{children}</BaseCartProvider>
  );

  return (
    <HistoryRouter history={reactTracker.connectToHistory(browserHistory)}>
      <CombinedProvider providers={[RoomProvider, CartProvider]}>
        <Routes>
          <Route path="/*" element={<AppLayout />} />
        </Routes>
      </CombinedProvider>
    </HistoryRouter>
  );
};

export default App;
